export default __webpack_public_path__ + "static/media/pt-title-cn.5cb83294.webp";